import type { Rubro } from './negocio';

/**
 * El color del negocio en el almacén.
 *
 * Los valores viven en `tokens.css`, bajo `[data-rubro="…"]`, y son los de la
 * familia del rubro del POS (`BrandPalette` en `app_colors.dart`): la botica
 * que cobra en verde veía su almacén violeta y creía estar en otro programa.
 * Aquí solo se dice cuál toca.
 *
 * **Sin sesión no hay rubro**: la entrada es de Lucqa, en su violeta, porque
 * todavía no se sabe de quién es el almacén. Por eso se quita al salir y no se
 * queda el color del último que entró.
 *
 * Devuelve cómo deshacerlo, para usarlo tal cual en un `useEffect`.
 */
export function pintarRubro(rubro: Rubro | null): () => void {
  const raiz = document.documentElement;

  // El restaurante también lleva el suyo aunque su color sea el de fábrica:
  // cada rubro se escribe una sola vez en el CSS y ninguno depende de que
  // falte el atributo.
  if (rubro === null) {
    delete raiz.dataset.rubro;
    return () => {};
  }

  raiz.dataset.rubro = rubro;
  return () => {
    delete raiz.dataset.rubro;
  };
}

